const VOICE_SEARCH_QUERY_MAX_LENGTH = 300

/** Truncate to max length at word boundary; remove last word if it doesn't fit */
export function truncateVoiceSearchResult(voiceResult: string): string {
  const trimmed = voiceResult.trim()
  if (trimmed.length <= VOICE_SEARCH_QUERY_MAX_LENGTH) return trimmed
  const truncated = trimmed.slice(0, VOICE_SEARCH_QUERY_MAX_LENGTH)
  const lastSpaceIndex = truncated.lastIndexOf(' ')
  return lastSpaceIndex === -1 ? '' : truncated.slice(0, lastSpaceIndex).trim()
}

export const createNotFoundError = (): Error => {
  const error = new Error('No microphone devices found')
  error.name = 'NotFoundError'
  return error
}
